export default "__VITE_ASSET__DsyaM4ck__"